import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common-service/common.service';
import { ChartType, GoogleChartsModule}from 'angular-google-charts';


@Component({
  selector: 'controls-bo-piechart',
  templateUrl: './bo-piechart.component.html',
  styleUrls: ['./bo-piechart.component.scss'],
  imports:[GoogleChartsModule]
})
export class BoPiechartComponent implements OnInit {
  @Input() chartForm!: FormGroup;
  chartType :any= ChartType.PieChart;
  myData = [];
   options = {
    title: '',
    legend: { position: 'bottom', textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
    pieHole: 0,
    pieSliceText: 'label',
    pieSliceTextStyle: { fontName: 'Hellix,sans-serif' },
    // slices: {
    //   1: { offset: 0.1 }
    // },
    chartArea: {
      bottom: 40,
      left: 20,
      right: 20,
      top: 20
    },

    colors: ['#a41f7c', '#9c0ab7', '#c60b50', '#2da5e4', '#f42c6a', '#06ddcd'],

  }
 
  cStyle: any = {};
  colors: any;

  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.commonService.ogLog('this.chartForm.value.data:', this.chartForm.value);
    if (this.chartForm.value.data) {
      this.myData = this.chartForm.value.data;
      this.cStyle = {
        width: this.chartForm.value.width,
        height: this.chartForm.value.height
      };
      if (this.chartForm.value['legendPosition'])
        this.options['legend'].position = this.chartForm.value['legendPosition'];
      if (this.chartForm.value['pieHole'])
        this.options['pieHole'] = this.chartForm.value['pieHole'];
      let chartArea = this.chartForm.value.chartArea;
      if (chartArea)
        this.options.chartArea = chartArea;
      this.colors = this.chartForm.value.colors;
      this.commonService.ogLog('this.colorspie', this.colors)
      if (this.colors)
        this.options.colors = this.colors;
    }

  }

}
